import React, { InputHTMLAttributes } from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegister,
} from "react-hook-form";
import FormError from "./FormError";

interface FormHiddenType extends InputHTMLAttributes<any> {
  register: UseFormRegister<any>;
  error: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
}

export default function FormHidden({
  name,
  register,
  error,
  ...props
}: FormHiddenType): React.ReactElement {
  return (
    <div>
      <input type="hidden" {...props} {...register(name ?? "")} />
      <FormError error={error} />
    </div>
  );
}
